import React, { useEffect, useReducer, useState } from "react";
import { Breadcrumb, Row, Button, Col, Glyphicon, Checkbox, ControlLabel } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import { connect } from "react-redux";
import locale from "../../../../../locale";
import SettingTabWrapper from "../../../Widgets/components/SettingTabWrapper";
import cloneDeep from "lodash.clonedeep";
import Tooltip from "../../../../UI/Tooltip";
import BlockSettings from "../../components/BlockSettings";
import Loading from "../../../../Loading";
import { pages, pagesSettingsUpdate } from "../../../../../../api/cp";
import CPSettingUploadImage from "../../../../UI/Settings/CPSettingUploadImage";
import { availableTypesBackground } from "../../../EventSettings/models";
import { FormGroup } from "@mui/material";
import FormControlLanguage from "../../../../UI/FormControlLanguage";
import CPSettingSize from "../../../../UI/Settings/CPSettingSize";

const ShopConstructorPage = ({ event }) => {
    const [pageData, setPageData] = useState(null);
    const [pageSettings, updatePageSettings] = useReducer(
        (prev, next) => {
            return { ...prev, ...next }
        },
        cloneDeep({})
    );

    const fetchPageData = async () => {
        const pagesList = await pages(event.eventKey);
        const shopPage = pagesList?.find(({ type }) => type === 'shop') ?? null;

        if (!!shopPage) {
            setPageData(shopPage)
            updatePageSettings({ ...pageSettings, ...shopPage.settings });
        }
    }

    useEffect(fetchPageData, []);

    const handleUpdateSettings = async (setting) => {
        const formData = new FormData();
        Object.keys(setting).forEach((key) => {
            formData.append(key, setting[key]);
        })
        const response = await pagesSettingsUpdate(pageData.id, formData);
        updatePageSettings({ ...pageSettings, ...response.settings });
    }

    if (!pageData) {
        return <Loading />
    }

    return (
        <section>
            <Row>
                <Breadcrumb>
                    <LinkContainer to={`/event/${event.eventPassword}`}>
                        <Breadcrumb.Item>{locale('mainMenu.event')}</Breadcrumb.Item>
                    </LinkContainer>
                    <LinkContainer to={`/event/${event.eventPassword}/pages`}>
                        <Breadcrumb.Item>{locale('mainMenu.pages')}</Breadcrumb.Item>
                    </LinkContainer>
                    <Breadcrumb.Item active>{locale('mainMenu.shopConstructor')}</Breadcrumb.Item>
                </Breadcrumb>
            </Row>
            <Row>
                <Col xs={12}>
                    <LinkContainer to={`/event/${event.eventPassword}/pages`}>
                        <Button>
                            <Glyphicon glyph="menu-left" />
                            {' '}
                            {locale('email.back')}
                        </Button>
                    </LinkContainer>
                </Col>
            </Row>
            <Row style={{ marginTop: '20px' }}>
                <Col xs={4}>
                    <SettingTabWrapper
                        label="СommonSettings"
                        title={locale('settings.tab.title.common')}
                    >
                        <ControlLabel>{locale('settings.title')}</ControlLabel>
                        <Checkbox
                            checked={pageSettings?.showTitle}
                            onChange={(e) => handleUpdateSettings({ showTitle: e.target.checked })}
                        >
                            {locale('settings.showTitle')}
                        </Checkbox>
                        {pageSettings?.showTitle && (
                            <FormGroup>
                                <FormGroup>
                                    <FormControlLanguage
                                        type="text"
                                        values={{
                                            ru: pageSettings.titleRu,
                                            en: pageSettings.titleEn,
                                        }}
                                        onChange={{
                                            ru: (e) => updatePageSettings({ titleRu: e.target.value }),
                                            en: (e) => updatePageSettings({ titleEn: e.target.value }),
                                        }}
                                        onBlur={() => handleUpdateSettings({ ...pageSettings, titleRu: pageSettings.titleRu, titleEn: pageSettings.titleEn })}
                                    />
                                </FormGroup>
                                <div style={{ display: 'flex', columnGap: '20px', marginTop: '12px' }}>
                                    <CPSettingSize
                                        name="titleSize"
                                        label={locale('settings.titleSize')}
                                        eventValue={pageSettings?.titleSize}
                                        defaultValue={'24px'}
                                        onChange={handleUpdateSettings}
                                    />
                                    <Checkbox
                                        checked={pageSettings.titleBold}
                                        onChange={(e) => handleUpdateSettings({ titleBold: e.target.checked })}
                                    >
                                        Bold
                                    </Checkbox>
                                </div>
                            </FormGroup>
                        )}
                        <hr />
                        <CPSettingUploadImage
                            eventImage={pageSettings.backgroundUrl}
                            title={locale('settings.uploadBackgroundImage')}
                            settingName="background"
                            hasCropper={false}
                            availableTypes={availableTypesBackground}
                            maxHeight="40px"
                            onUpdate={handleUpdateSettings}
                        />
                        <Checkbox
                            checked={pageSettings?.backgroundFixed || false}
                            onChange={(e) => handleUpdateSettings({ backgroundFixed: e.target.checked })}
                        >
                            {locale('settings.backgroundFixed')}
                            <Tooltip width="300px">
                                {locale('settings.backgroundFixedTooltip')}
                            </Tooltip>
                        </Checkbox>
                    </SettingTabWrapper>
                    <SettingTabWrapper
                        label="BlockSettings"
                        title={locale('settings.tab.title.blocks')}
                    >
                        <BlockSettings
                            event={event}
                            pageId={pageData.id}
                            pageTemplate={pageData.template}
                            blocks={pageData.blocks}
                            updatePageSettings={handleUpdateSettings}
                        />
                    </SettingTabWrapper>
                </Col>
                <Col xs={8}>
                    <iframe
                        name={pageData?.type + "Page"}
                        src={`/event/${event.eventKey}/shop`}
                        style={{ width: '100%', height: '100dvh' }}
                        frameBorder="0"
                    />
                </Col>
            </Row>
        </section>
    )
}

const mapStateToProps = (store) => ({
    event: store.currentEvent,
});

export default connect(mapStateToProps)(ShopConstructorPage);